<script>

    import {cartTotalStore} from "../cart/cart-store.js";
    import {isPaidStore, publishConfigStore, tenantKeyStore} from "../core/app-store.js";

</script>

<style>

    footer {
        height: 70vh;
        padding: 0 1rem;
    }

    .content {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        text-align: center;
        padding: 2rem 2rem;
    }

    .logo-container {

    }

    .logo-image {
        width: 40vw;
        height: 40vw;
        display: block;
        border-radius: 4px;
    }
    @media (min-width: 768px) {
        .logo-image {
            width: 100px;
            height: 100px;
        }
    }

    h2 {
        text-transform: uppercase;
        color: var(--accent);
        font-size: var(--fs-150);
        font-weight: 400;
    }
    @media (min-width: 768px) {
        h2 {
            font-size: 2.75rem;
        }
    }

    .dm-label {
        border-top: 1px solid var(--semi-transpagent-red);
        color: var(--secondary-text);
        text-align: center;
        padding: 1.5rem;
    }

    .cart-space {
        height: 5rem;
    }

</style>

<footer class="layer-sections flex-column jc-center ai-center">

    <div class="content flex-fill">

        {#if $publishConfigStore.logoUrl}
            <div class="logo-container flex jc-center ai-center">
                <object class="logo-image"
                        data="https://digital-menu-ru.2men.us/{$tenantKeyStore}{$publishConfigStore.logoUrl}"
                        type="image/png">
                    <img class="full-width full-height"
                         src="./images/fallback-logo-image.svg"
                         alt={$publishConfigStore.restaurantName}>
                </object>
            </div>
        {/if}

        <h2>{$publishConfigStore.restaurantName}</h2>

        {#if $publishConfigStore.restaurantAddress}
            <div>
                <div>
                    {$publishConfigStore.restaurantAddress}
                </div>

                <div>
                    {#if ($publishConfigStore.restaurantAddressLinkAction === 'yandex-maps' && $publishConfigStore.restaurantAddressLink)}
                        (<a href="{$publishConfigStore.restaurantAddressLink}" target="_blank" rel="nofollow noopener">карта</a>)
                    {:else if ($publishConfigStore.restaurantAddressLinkAction === 'geo' && $publishConfigStore.restaurantAddressGeo)}
                        <span class="hide-on-desktop">(<a href="geo:{$publishConfigStore.restaurantAddressGeo}" target="_blank" rel="nofollow noopener">карта</a>)</span>
                    {:else if ($publishConfigStore.restaurantAddressLinkAction !== 'none')}
                        (<a href="https://maps.google.com/?q={$publishConfigStore.restaurantAddress}" target="_blank" rel="nofollow noopener">карта</a>)
                    {/if}
                </div>
            </div>
        {/if}
    </div>

    {#if !$isPaidStore }
        <div class="dm-label full-width">
            Меню сделано с <a href="https://digital-menu.ru/?utm_source=menu&utm_medium=footer&utm_campaign={$tenantKeyStore}">digital-menu.ru</a>
        </div>
    {/if}

    {#if ($cartTotalStore?.count > 0)}
        <div class="cart-space"></div>
    {/if}
</footer>
